module.exports = __webpack_public_path__ + "static/media/paypal.0d3a5524.png";